import React from 'react';
import { PropTypes } from 'prop-types';

function Loading(props) {
    const { isLoading, error } = props;

    if (isLoading) {
        return (
            <div>Page is loading, please wait...</div>
        );
    }
    if (error) {
        return (
            <div>Sorry, there was a problem loading the page.</div>
        );
    }
    return null;
}

Loading.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.objectOf(PropTypes.any),
};

Loading.defaultProps = {
    error: undefined,
};

export default Loading;
